module.exports = __webpack_public_path__ + "static/letsencrypt-a9a08cd79a92eb7f8293c3472b60373f.svg";